<dxp-link state="enabled" open-in-new-tab="false" type="dxp-btn-custom-link" [text]="this.params.value"
    aria-label="Click on the link to perform action" (click)="triggerAction(this.params.data)">
</dxp-link>